import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { BioCategorySection } from './BioCategorySection';
import { BioMemberModal } from './BioMemberModal';
import styles from './BioPageBody.module.scss';
/**
 * Renders the intro content, category sections, and member detail modal for
 * the bio page. Takes `content` as a prop rather than reading a data source
 * directly so Phase 2 can swap a fetched API response in for the Phase 1
 * hardcoded content without touching this component.
 */
export const BioPageBody = ({ content }) => {
    const [selectedMember, setSelectedMember] = useState(null);
    return (_jsxs(_Fragment, { children: [_jsx("section", { className: styles.info, children: _jsx("div", { dangerouslySetInnerHTML: { __html: content.introContent } }) }), content.categories.map((category) => (_jsx(BioCategorySection, { category: category, onSelectMember: setSelectedMember }, category.id))), _jsx(BioMemberModal, { member: selectedMember, onClose: () => setSelectedMember(null) })] }));
};
